export type EntityId = string | number
export interface BaseEntityState<E extends { id: EntityId }> {
  entities: E[]
  isLoading: boolean
  error: string | null
}
export const createInitialBaseState = <E extends { id: EntityId }>(entities: E[] = []): BaseEntityState<E> => ({
  entities,
  isLoading: false,
  error: null,
})

export interface BaseSingletonState {
  isLoading: boolean
  error: string | null
}

export const createInitialSingletonState = (): BaseSingletonState => ({
  isLoading: false,
  error: null,
})
